import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel } from "@angular/material/snack-bar";
import { SnackBar } from "../models/snack-bar.interface";

@Component({
    selector: 'cec-snack-bar',
    standalone: true,
    templateUrl: './snack-bar.component.html',
    styleUrl: './snack-bar.component.scss',
    imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
  })
  export class SnackBarComponent {

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBar) { }

  }